// extracted by mini-css-extract-plugin
module.exports = {"navbar":"NavBar_navbar__yNL3i","icon":"NavBar_icon__1HbMg","link":"NavBar_link__2Iixg","active":"NavBar_active__1HRI5"};